{
  "de": {
    "baseBtn": {
      "labels": {
        "loading": "Bitte warten..."
      }
    }
  }
}
